export default __webpack_public_path__ + "static/media/25.8cb2b9b6.jpg";